/*eslint-disable*/

import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import {loginRedirectQuery, loginReturnTarget} from './loginReturn'
import {hasClientSession} from './authSession'
import store from '../store'
import {i18n} from "@/plugins/vuetify";
import {EventBus} from "@/event-bus";
import {hasIntakePending, markIntakePending} from "@/intake/intakeState";
import {shouldRedirectStaticIntakeRoute} from "@/intake/v2IntakeRouteGate";

function intakeEntryRouteName() {
    return 'intakeScreening'
}

/** Preserve return target when auth guard bounces unauthenticated users to login. */
function afterLoginTargetFor(to) {
    const named = to.matched
        .map((record) => record.name)
        .filter(Boolean)
        .reverse()
    if (named.length) {
        return named[0]
    }
    if (String(to.path || '').includes('/intake')) {
        return intakeEntryRouteName()
    }
    return null
}

Vue.use(VueRouter)


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})


router.beforeEach((to, from, next) => {
    const loggedIn = hasClientSession(localStorage)
    if (to.name == 'MainLayout') {
        next({name: 'portalHome', params: {lang: to.params.lang || 'fa'}, query: to.query, hash: to.hash})
        return;
    }
    if (store.state.languages.findIndex(item => item == to.params.lang) != -1) {
        store.dispatch('setLocal', to.params.lang)
    } else {
        store.dispatch('setLocal', 'fa')
        // localStorage.setItem('local', 'fa')
    }

    // V2 screening: block static draft question routes → composed screening
    if (shouldRedirectStaticIntakeRoute(to.name)) {
        next({
            name: 'intakeScreening',
            params: {lang: to.params.lang || 'fa'},
            query: to.query,
            replace: true,
        })
        return
    }

    if (to.matched.some((record) => record.meta.auth)) {
        if (loggedIn) {
            // if (store.getters.getProfile && to.meta.checkRequiredFiled) {
            //     let profile = store.getters.getProfile
            //     // if ((profile.requiredFields.length != 0 || profile.cycles.length == 0) && !profile.leadUser) {
            //     //     next('/fa/onboarding-new')
            //     //     return;
            //     // }
            //     // if (profile.requiredFields.length != 0 && profile.leadUser) {
            //     //     next('/fa/panel/user-onboarding')
            //     //     return;
            //     // }
            // }
            next()
            return;
        } else {
            const afterLogin = afterLoginTargetFor(to)
            if (afterLogin && String(afterLogin).startsWith('intake')) {
                markIntakePending()
            }
            next({
                name: 'login',
                params: {lang: to.params.lang || 'fa'},
                query: loginRedirectQuery(to, afterLogin),
            })
            return
        }
    }
    if (to.meta.guest) {
        if (loggedIn) {
            const returnTarget = loginReturnTarget(to, router)
            if (returnTarget) {
                next(returnTarget)
                return;
            }

            if (hasIntakePending()) {
                next({name: intakeEntryRouteName(), params: {lang: to.params.lang || 'fa'}})
                return
            }

            next({name: 'portalHome', params: {lang: to.params.lang || 'fa'}})
            return;
        }
    }

    next()
    return
})

export default router
